const REGIONS = {
  SG: 'SGD',
  CN: 'CNY',
  TH: 'THB',
  IN: 'INR',
  VN: 'VND',
  AU: 'AUD',
  MY: 'MYR',
  ID: 'IDR',
  TW: 'TWD',
  HK: 'HKD',
  NZ: 'NZD',
  KR: 'KRW',
  PH: 'PHP',
  TR: 'TRY',
  JP: 'JPY',
  US: 'USD',
  EU: 'EUR',
  DE: 'EUR',
  SS: 'SGD',
  MX: 'USD',
  BR: 'BRL',
};

// Region code -> country name (mirrors the backend REGION_NAME_MAPPED).
const REGION_NAMES: Record<string, string> = {
  SG: 'Singapore',
  CN: 'China',
  TH: 'Thailand',
  IN: 'India',
  VN: 'Vietnam',
  AU: 'Australia',
  MY: 'Malaysia',
  ID: 'Indonesia',
  JP: 'Japan',
  HK: 'Hongkong',
  DE: 'German',
  BR: 'Brazil',
  MX: 'Mexico',
  PH: 'Philippines',
};

// Regional mailbox outbound emails are always CC-ed to,
// e.g. SG -> singapore@sourcesage.co
const regionCcEmail = (region?: string | null) => {
  const code = (region || '').trim().toUpperCase() || 'SG';
  const name = REGION_NAMES[code] || code;
  return `${name.toLowerCase().replace(/ /g, '_')}@sourcesage.co`;
};

export { REGIONS, REGION_NAMES, regionCcEmail };
